import React from 'react';
import { withRouter } from 'react-router-dom';
import { completeSignIn } from '../api/EmailLinkAuthentication'
import { validUserProfile, getContinueUrl } from '../api/FirebaseAPI'


class CompleteSignIn extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      message:'Completing sign-in'
    }
  }
  async componentWillMount() {
    var url = window.location.href
    try {
      if (await completeSignIn(url)) {
        var continueUrl = getContinueUrl(url)
        var pathname = new URL(continueUrl).pathname

        if (pathname === '/unauthorised') pathname = '/'
        
        if (await validUserProfile()) {
          console.log('valid profile', await validUserProfile())
          this.props.history.replace(pathname)
        }
        else {
          console.log('invalid profile')
          const url = '/myprofile?continueUrl=' + encodeURIComponent(pathname)
          this.props.history.replace(url)
        }
      }
    } catch (error) {
      this.setState({message:error.message  + `Try signing in again.`})
    }
  }
  render() {
    return <div style={{textAlign:'center', padding:'50px 20px 50px 20px'}}>{this.state.message}</div>
  }
}

export default withRouter(CompleteSignIn)


/*
first_name*
last_name*
contact number*
business

*/



// WEBPACK FOOTER //
// ./src/containers/CompleteSignIn.js